import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-call-confirm-modal',
  standalone: true,
  templateUrl: './call-confirm-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallConfirmModalComponent {
  title = input.required<string>();
  description = input.required<string>();
  cancelText = input<string>('Hủy');
  confirmText = input<string>('Tiếp tục');

  cancelEvt = output<void>();
  confirmEvt = output<void>();
}
